export default __webpack_public_path__ + "3b075142db763b24c3930abc1070fada.svg";